
import { Component, Vue } from 'vue-property-decorator'
import {
  StudyData,
  GeneralSummaryData,
  SubjectSummaryData,
  ProblemTagSummaryData,
} from '@/models/api/common/SummaryResultTypes.vue'

/**
 * SummaryResultでのAPIリクエスト
 */
@Component
export default class SummaryResultApis extends Vue {
  /**
   * テスト情報取得
   */
  protected async getStudy(studyContentId: string): Promise<StudyData> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`/v1/study_contents/${studyContentId}`)
    return {
      studyName: data.studyName,
      studyModeCode: data.studyModeCode,
      grades: data.grades.map((obj: { id: number; name: string }) => {
        return { value: obj.id, text: obj.name }
      }),
    }
  }

  protected async getSummary(studyContentId: string): Promise<GeneralSummaryData> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`/v1/branch/summary/${studyContentId}/whole`)
    return data
  }

  protected async getSubjectSummary(studyContentId: string): Promise<SubjectSummaryData[]> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`/v1/branch/summary/${studyContentId}/subjects`)
    return data
  }

  protected async getProblemTagSummary(studyContentId: string): Promise<ProblemTagSummaryData[]> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`/v1/branch/summary/${studyContentId}/problem_tags`)
    return data
  }

  /** テスト結果集計タスク実行 */
  protected async execStudySummaryTaskApi(): Promise<void> {
    await Vue.prototype.$http.httpWithToken.get(`/v1/branch/summary/exec_task`)
  }
}
